import { VideoSelfingStore } from './services/videoselfing.store';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from '@app/material.module';
import { RequestsSharedModule } from '../requests/@shared';
import { LandingVideoselfingRoutingModule } from './landing-videoselfing-routing.module';
import { LandingVideoselfingComponent } from './landing-videoselfing.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VideoselfingApi } from './services/videoselfing-api.service';
import { SharedModule } from '@app/@shared';
import { VideoselfingConsentDialogModule } from '@app/videoselfing-consent/videoselfing-consent.module';

@NgModule({
  declarations: [LandingVideoselfingComponent],
  imports: [
    CommonModule,
    RequestsSharedModule,
    MaterialModule,
    FlexLayoutModule,
    LandingVideoselfingRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    VideoselfingConsentDialogModule,
  ],
  providers: [VideoselfingApi, VideoSelfingStore],
})
export class LandingVideoselfingModule {}
